import { EntityBase } from "./EntityBase";
import { FuelType } from "./FuelType";

export class RateClass extends EntityBase {
    active: boolean | null = null;
    name: string | null = null;
    isDemandBased: boolean | null = null;
    isCommercial: boolean | null = null;
    searchKey: string | null = null;
    fuelType: FuelType | null = null;
}
